export default "__VITE_ASSET__CssMDkMa__"